import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-remote-hw-station",
  "use": "icon-soc-remote-hw-station-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-remote-hw-station\">\r\n  <rect x=\"192\" y=\"192\" width=\"640\" height=\"480\" rx=\"32\" fill=\"currentColor\" />\r\n  <path fill=\"#fff\" fill-opacity=\".3\" d=\"M256 256h512v64H256z\" />\r\n  <rect x=\"320\" y=\"720\" width=\"384\" height=\"48\" rx=\"8\" fill=\"currentColor\" />\r\n  <circle cx=\"512\" cy=\"448\" r=\"72\" fill=\"#fff\" fill-opacity=\".5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-remote-hw-station.svg
// module id = Han7
// module chunks = 546